import { Search, List, Network } from 'lucide-react';
import { Input } from '@/components/Input';

export type CollectionViewMode = 'tree' | 'table';

interface CollectionFiltersProps {
  search?: string;
  viewMode: CollectionViewMode;
  onSearchChange: (value: string) => void;
  onViewModeChange: (mode: CollectionViewMode) => void;
}

export function CollectionFilters({
  search = '',
  viewMode,
  onSearchChange,
  onViewModeChange,
}: CollectionFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
      {/* Search */}
      <div className="flex-1">
        <Input
          type="text"
          placeholder="Search collections..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          leftIcon={<Search className="h-5 w-5" />}
        />
      </div>

      {/* View Mode Toggle */}
      <div className="flex gap-1 p-1 bg-background-subtle rounded-lg flex-shrink-0">
        <button
          onClick={() => onViewModeChange('tree')}
          className={`p-2 rounded transition-colors ${
            viewMode === 'tree'
              ? 'bg-background text-foreground'
              : 'text-foreground-muted hover:text-foreground'
          }`}
          aria-label="Tree view"
          title="Tree view"
        >
          <Network className="h-5 w-5" />
        </button>
        <button
          onClick={() => onViewModeChange('table')}
          className={`p-2 rounded transition-colors ${
            viewMode === 'table'
              ? 'bg-background text-foreground'
              : 'text-foreground-muted hover:text-foreground'
          }`}
          aria-label="Table view"
          title="Table view"
        >
          <List className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
